import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface RosterSlice {
  /** Groups person by order renewal status */
  groupByOrderStatus: boolean;
  rowGroupExpanded: Record<string, boolean>;
}

const initialState: RosterSlice = {
  groupByOrderStatus: false,
  rowGroupExpanded: {},
};

export const rosterSlice = createSlice({
  name: 'rosterSlice',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toggleGroupByOrderStatus: (state, _action: PayloadAction<undefined>) => {
      state.groupByOrderStatus = !state.groupByOrderStatus;
    },

    toggleExpandGroup: (
      state,
      action: PayloadAction<{
        groupId: string;
        toggle: boolean;
        type: 'order-status'; // TODO: this will support other group types
      }>,
    ) => {
      const { groupId, toggle, type } = action.payload;
      const key = `${type}:${groupId}`;
      state.rowGroupExpanded[key] = toggle;
    },
  },
});

const { actions, reducer } = rosterSlice;

export { reducer };

export const { toggleGroupByOrderStatus, toggleExpandGroup } = actions;
